import React from 'react'
import { Previewer } from 'pagedjs'
import { isMedia } from 'utils/browser'
// eslint-disable-next-line import/no-webpack-loader-syntax
import RAW_CSS from '!raw-loader!./paged.css' // css as raw string
// eslint-disable-next-line import/no-webpack-loader-syntax
import RAW_FOOTLESS_CSS from '!raw-loader!./pagedFootless.css' // css as raw string, no footer

// sentinel value that puppeteer looks for before starting pdf rendering
const RENDER_ID = '__SENTINEL__'

// Use paged.js as polyfill to render paged media css such as @page
type PagedProps = {
  children?: React.ReactNode
  enabled?: unknown
  noFooter?: boolean
}

const Paged = ({
  children,
  enabled = children && isMedia('print'),
  noFooter,
}: PagedProps) => {
  React.useEffect(() => {
    if (!enabled) return

    setTimeout(() => {
      timestamp('useEffect')
      const renderToExists = document.querySelector(`#${RENDER_ID}`)
      if (renderToExists) return

      // #app is the application root; it is always present by this point.
      const renderFrom = document.querySelector<HTMLElement>('#app')!
      const renderTo = document.createElement('div')
      renderTo.id = RENDER_ID
      renderFrom.style.visibility = 'hidden'
      renderTo.style.visibility = 'hidden'
      document.body.appendChild(renderTo)
      new Previewer()
        .preview(
          renderFrom.innerHTML,
          [{ css: noFooter ? RAW_FOOTLESS_CSS : RAW_CSS }],
          renderTo,
        )
        .then(flow => {
          renderFrom.style.display = 'none'
          renderTo.style.visibility = ''
          timestamp(`preview rendered ${flow.total} pages`)
        })
      return function cleanup() {
        renderTo.remove() // paged.js rendered content in document <body/>
        document.head // paged.js inserted style nodes in document <head/>
          .querySelectorAll('style')
          .forEach(
            style =>
              (!style.innerText || style.dataset.pagedjsInsertedStyles) &&
              style.remove(),
          )
        renderFrom.style.display = ''
        renderFrom.style.visibility = ''
        timestamp('unmount')
      }
    }, 0)
  }, [])

  return children
}

// write timestamps to console to log performance with puppeteer
const timestamp = (message: string) => {
  console.debug(
    JSON.stringify({
      route: window.location.pathname,
      time: performance.now().toFixed(2),
      message,
    }),
  )
}

export default Paged
